module.exports = __webpack_public_path__ + "static/zapier-16e7b4959ddbfa2e781e877181fa25b5.png";